import { tw } from "@careinfo/tailwind";
import React from "react";
import loadable from "@loadable/component";
import CreateIcon from "../../Icons/CreateIcon";
import usePostHook from "../../customHooks/usePostHook";
import APIS from "../../constant/Endpoint";
const CreateShipviaComponent = loadable(
  () => import("../../components/Shipvia/CreateShipvia")
);
const CreateShipvia = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["ship-via"],
    navigateURL: "/",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.SHIP_VIA}`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <div>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Ship Via
        </span>
      </div>
      <CreateShipviaComponent
        handleCreate={handleCreate}
        isLoading={isPostLoading}
      />
    </div>
  );
};

export default CreateShipvia;
